import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useParams } from "react-router-dom";
import { getDatabase, ref, onValue } from "firebase/database";
import '../../style/Leaderboard.css';
import NoSleep from "nosleep.js"; 

export default function LeaderBoard({ onNavigate , code: propCode}) {
  const { code: urlCode } = useParams();
  const { slug } = useParams();
  const code = propCode || urlCode;
  const initial = localStorage.getItem('initials');
  const fullname = localStorage.getItem('name');
  const profileColor = localStorage.getItem('profileColor');
  const allocatedTeam = localStorage.getItem('allocatedTeam');
  const allocatedTeamColor = localStorage.getItem('allocatedTeamColor');
  const [currentScore, setCurrentScore] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [participants, setParticipants] = useState([]);
  const [bonusAnimation, setBonusAnimation] = useState(false);
  const noSleep = new NoSleep();
  // useEffect(() => {
  //   const enableNoSleep = () => {
  //     if (document.visibilityState === 'visible') {
  //       try {
  //         noSleep.enable();
  //       } catch (error) {
  //         alert(`Unable to disable sleep: ${error}`);
  //       }
  //     }
  //   };

  //   // Call enableNoSleep initially
  //   enableNoSleep();

  //   // Set up a visibility change listener to disable/enable noSleep based on visibility
  //   document.addEventListener('visibilitychange', enableNoSleep);

  //   return () => {
  //     // Cleanup: Remove event listener and disable noSleep when component unmounts
  //     document.removeEventListener('visibilitychange', enableNoSleep);
  //     noSleep.disable();
  //   };
  // }, []);
  useEffect(() => {
    if (code) {
   
      handleFirebaseUpdatebycode();
    }else{
      handleFirebaseUpdatebyslug(); 
    }
  }, [code, allocatedTeam, onNavigate, fullname]);

  const handleFirebaseUpdatebycode = () => {
    const database = getDatabase();
    const refPath = ref(database, `AppleTV/${code}`);
    let previousData;

    onValue(refPath, (snapshot) => {
      const data = snapshot.val();
      if (data !== previousData) {
        previousData = data;

        const currentteam = data.currentteam;
        const command = data.command;

        if (command === '7010') {
          onNavigate('PlayerWinnerParticipant');
        }
        if (command === '7001' && allocatedTeam === currentteam) {
          onNavigate('PlayScreenParticipant');
        }
        if (data.command === '7020') {
          const keysToRemove = [
            'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
            'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
            'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor', 'code'
          ];
        
          // Clear local storage
          keysToRemove.forEach((key) => {
            window.localStorage.removeItem(key);
          });
        
          // Use a short timeout to ensure localStorage operations finish before redirecting
          setTimeout(() => {
            window.location.href = 'https://play.triviamaker.com/';
          }, 0);
        }
        

        const teamParticipants = data.teamNames.map((team) => {
          const participantScore = data.scores?.[team.name]?.score ?? 0;
          return {
            initials: team.initials,
            name: team.name,
            profileColor: team.profileColor,
            score: participantScore,
            animate: data.scores?.[team.name]?.animate ?? false,
          };
        });

        teamParticipants.sort((a, b) => b.score - a.score);

        const currentParticipant = teamParticipants.find(p => p.name === fullname);
        if (currentParticipant) {
          if (currentParticipant.animate && !isAnimating) {
            triggerBonusAnimation(currentParticipant.score);
          } else {
            setCurrentScore(currentParticipant.score);
          }
        }

        setParticipants(teamParticipants);
      }
    });
  }

  const handleFirebaseUpdatebyslug = () => {
    const database = getDatabase();
    const refPath = ref(database, `AppleTV/${slug}`);
    let previousData;

    onValue(refPath, (snapshot) => {
      const data = snapshot.val();
      if (data !== previousData) {
        previousData = data;

        const currentteam = data.currentteam;
        const command = data.command;

        if (command === '7010') {
          onNavigate('PlayerWinnerParticipant');
        }
        if (command === '7001' && allocatedTeam === currentteam) {
          onNavigate('PlayScreenParticipant');
        }
        if (data.command === '7020') {
          const keysToRemove = [
            'wordToGuess', 'guessedLetters', 'wrongGuesses', 'currentTeam', 'score',
            'currentScreen', 'roundWinners', 'selectedRound', 'startTime', 'allocatedTeam',
            'allocatedTeamColor', 'currentScreenParticipantside', 'initials', 'name', 'profileColor', 'code'
          ];
        
          keysToRemove.forEach((key) => window.localStorage.removeItem(key));
        
          // Wait a bit before redirecting
          setTimeout(() => {
            console.log('Redirecting after clearing localStorage...');
            window.location.href = 'https://play.triviamaker.com/';
          }, 100); // Adjust delay if needed
        }
            

        const teamParticipants = data.teamNames.map((team) => {
          const participantScore = data.scores?.[team.name]?.score ?? 0;
          return {
            initials: team.initials,
            name: team.name,
            profileColor: team.profileColor,
            score: participantScore,
            animate: data.scores?.[team.name]?.animate ?? false,
          };
        });

        teamParticipants.sort((a, b) => b.score - a.score);

        const currentParticipant = teamParticipants.find(p => p.name === fullname);
        if (currentParticipant) {
          if (currentParticipant.animate && !isAnimating) {
            triggerBonusAnimation(currentParticipant.score);
          } else {
            setCurrentScore(currentParticipant.score);
          }
        }

        setParticipants(teamParticipants);
      }
    });
  }


  const triggerBonusAnimation = (targetScore) => {
    setBonusAnimation(true);
    setTimeout(() => {
      setBonusAnimation(false);
      startAnimation(targetScore);
    }, 1500); // Duration of the `+100` animation
  };

  const startAnimation = (targetScore) => {
    if (isAnimating || targetScore === currentScore) return;
    const startScore = targetScore - 100; // Start from currentScore - 100
    setIsAnimating(true);
    const duration = 1000; // Animation duration in milliseconds
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1); // Normalize to [0, 1]
      const newScore = Math.floor(startScore + progress * (targetScore - startScore));

      setCurrentScore(newScore); // Update the score state

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        setIsAnimating(false); // Animation complete
      }
    };

    requestAnimationFrame(animate);
  };



  return (
    <>
      <div className="leaderboardMain">
        <div className="Teamassigned row" style={{ background: allocatedTeamColor }}>
          <span className="teamnameassignid">You are on {allocatedTeam}</span>
        </div>
        <div id="commonplayersscorboard" className="common-players-scoreboard row">
          <div className="col-xl-4 col-lg-3 col-md-1 col-sm-1 col-xs-0"></div>
          <div className="col-xl-4 col-lg-6 col-md-10 col-sm-10 col-xs-12 padding-fix">
            <div className="score-container">
              <div className="topscorebarclass" id="topscorebar">
                <div className="initial-letter-container">
                  <span id="commominitialletterid" className="animallistcircle initial-letter" style={{ background: profileColor }}>
                    {initial}
                  </span>
                </div>

                <div className="teamtitle ellipsis-text">
                  <span id="commonusernameid">{fullname}</span>
                </div>

                <div className="score-title-container">
                  <span className="scortextspanclass" id="topbarscoretitle">Score</span>
                </div>
                <div id="scorebox" className='scorebox' >
                  <div className='score-display' >
                    {bonusAnimation ? (
      <motion.div
      initial={{ opacity: 1, scale: 1 }}           // Start at original size with 0 opacity
      animate={{
        opacity: 1,
        scale: [1, 1.5, 1],                        // Zoom out to 1.5x, then zoom back to 1
      }}
      transition={{
        duration: 1,                               // Total duration of the animation
        times: [0, 0.5, 1],                        // Timing for each keyframe
      }}
      exit={{ opacity: 1, scale: 1 }}              // Exit animation to fade out at original size
      className="bonus-score-animation"
    >
      +100
    </motion.div>
    
            
                    ) : (
                      <span id="currentscoreid" className='currentscoreidanimate'>
                        {currentScore}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-3 col-md-1 col-sm-1 col-xs-0"></div>
        </div>

        <div className="row top">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 leaderboard-container">
            <div className="leaderboardwidth">
              <div className="leaderboardblackboard">
                <div className="blackleaderboard">
                  <div className="leaderboard-text">
                    <span id="leaderboardtext">Watch the host's screen<br />and get ready<br />to answer</span>
                  </div>
                </div>
              </div>
              <div className="leaderboard-section">
                <div className="leaderboard-section-text">
                  <span id="leaderboardspan">Leaderboard</span>
                </div>
              </div>
              <div id="basicchartdivid" className="basicscoreboardcss">
                <ul id="leaderboardusersid" className="leaderboard-list">
                  {participants.map((participant, index) => (
                    <li
                      key={index}
                      className="leaderboard-item"
                      style={{ top: `${index * 68}px` }}
                    >
                      <div className="leaderboard-content">
                        <div className="leaderboard-left">
                          <span
                            className="animallistcircle"
                            style={{ background: participant.profileColor, color: "white" }}
                          >
                            {participant.initials}
                          </span>
                        </div>
                        <div className="teamanimalname">
                          <span className="animalscreenlabel">{participant.name}</span>
                        </div>
                        <div className="leaderboard-right">
                          <span className="leaderboard-score">{participant.score}</span>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

